import React from 'react';

import CatalogoEstadosSeguimiento from './CatalogoEstadosSeguimiento';
import { getEstadoSeguimientoSeg, tablaEstadoSeguimientoSeg } from '../../../querys/EstadosSeguimiento';
import { addEstadoSeguimientoSeg, updateEstadoSeguimientoSeg, deleteEstadoSeguimientoSeg } from '../../../mutations/EstadosSeguimiento';

function EstadosSeguimientoSeguros() {
    return <CatalogoEstadosSeguimiento
        titulo="Estados de Seguimiento Seguros"
        asyncGet={getEstadoSeguimientoSeg}
        asyncTabla={tablaEstadoSeguimientoSeg}
        asyncAdd={addEstadoSeguimientoSeg}
        asyncUpdate={updateEstadoSeguimientoSeg}
        asyncDelete={deleteEstadoSeguimientoSeg}
    />;
}

export default EstadosSeguimientoSeguros;
